import React from 'react';
import { getDeviceName } from "../../../../../../Utils";

const params = [ 'spends', 'conversions', 'eCost' ];

const Row = ({ affid, subid, device, country, days, daysData }) => {
    const daysTd = days.reduce((arr, day) => {
        params.forEach(param => arr.push(<td key={`${day}_${param}`}>{daysData[day][param]}</td>));

        return arr;
    }, []);

    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{getDeviceName(device)}</td>
            <td>{country}</td>
            {daysTd}
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/DaysTable/components/Row/index.js